import React from 'react'
import ReactDOM from 'react-dom'
import '../src/styles/index.css'
import App from './App'
import { AppProvider } from '../src/context/context'

ReactDOM.render(
  <React.StrictMode>
    <AppProvider>
      <App />
    </AppProvider>
  </React.StrictMode>,
  document.getElementById('root')
)
